import { yupResolver } from '@hookform/resolvers/yup';
import { NewPaymentContext } from 'components/payment/payment.context';
import Spinner from 'components/spinner/spinner.component';
import { useContext, useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import SpreedlyContext from '../spreedly.context';
import SpreedlyForm from './forms/spreedly-form.component';
import { getSchema } from './spreedly-card.utils';
import { useCheckoutPaymentLoading } from 'pages/checkout/checkout.component';
import { useSelector } from 'react-redux';
import { useIsNewSpreedlyCardFlow } from 'components/payment/payment-selector/credit-card-panel/credit-card-panel-controller/credit-card-panel-controller.hooks';
import { selectIsLoggedIn } from 'redux/user/user.selectors';
import { spreedlyFormSubmit } from './forms/spreedly-form.hooks';

const SpreedlyCard303942 = ({ handleCardInfo, button }) => {
  const { initOrderResponse, refetchInitOrder } = useContext(NewPaymentContext);
  const initOrderAttributes = initOrderResponse?.attributes;
  const formName = initOrderAttributes?.hostedPaymentPageName;
  const methods = useForm({
    mode: 'onBlur',
    reValidateMode: 'onBlur',
    resolver: yupResolver(getSchema(formName)),
  });
  const { handleSubmit } = methods;
  const {
    setSubmitSpreedlyForm,
    spreedlyScriptLoading,
    setCardInfo,
    setTokenizationSuccess,
  } = useContext(SpreedlyContext);
  const setPaymentLoading = useCheckoutPaymentLoading(
    state => state.setLoading,
  );
  const paymentLoading = useCheckoutPaymentLoading(state => state.loading);
  const addPromise = useCheckoutPaymentLoading(state => state.addPromise);
  const isLoggedIn = useSelector(selectIsLoggedIn);
  const isNewSpreedlyCardFlow = useIsNewSpreedlyCardFlow();
  const showSaveCardCheckbox = isLoggedIn && isNewSpreedlyCardFlow;

  const onSuccess = async (_token, paymentMethod) => {
    const { token, full_name, month, year } = paymentMethod;
    setTokenizationSuccess(true);
    if (!!handleCardInfo) {
      const res = await addPromise(
        handleCardInfo({ token, full_name, month, year }),
      );
      if (!res) await addPromise(refetchInitOrder());
    } else {
      // I cannot, for the life of me, get form values in here. They are
      // always undefined. So, I'm just querying the DOM directly for the checkbox.
      const savePaymentInstrument = document.getElementById(
        'savePaymentInstrument',
      )?.checked;
      setCardInfo({
        token,
        savePaymentInstrument,
        cardNickname: savePaymentInstrument ? full_name : undefined,
      });
    }
  };

  const onError = () => {
    setPaymentLoading(false);
    refetchInitOrder();
  };

  const submit = spreedlyFormSubmit(handleSubmit, data => {
    window.Spreedly.tokenizeCreditCard(data);
    setPaymentLoading(true);
  });

  useEffect(() => {
    setSubmitSpreedlyForm(_state => submit);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return spreedlyScriptLoading ? (
    <Spinner />
  ) : (
    <FormProvider {...methods}>
      <SpreedlyForm
        formName={formName}
        initOrderAttributes={initOrderAttributes}
        onSuccess={onSuccess}
        onError={onError}
        showSaveCardCheckbox={showSaveCardCheckbox}
        button={button}
        disabled={paymentLoading}
        submit={submit}
      />
    </FormProvider>
  );
};

export default SpreedlyCard303942;
